/* eslint-disable arrow-body-style */
/* eslint-disable prettier/prettier */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable react/self-closing-comp */ /* eslint-disable prettier/prettier */

import { Dialog, DialogTitle, DialogContent, Button, DialogActions } from '@mui/material';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { useState } from 'react';

function CropImageDialog({ open, image, handleClose, handleFile }) {
  const [cropper, setCropper] = useState(null);

  const getCropData = async () => {
    if (cropper) {
      const file = await fetch(cropper.getCroppedCanvas().toDataURL())
        .then((res) => res.blob())
        .then((blob) => {
          return new File([blob], 'newAvatar.png', { type: 'image/png' });
        });
      if (file) {
        handleFile(file);
      }
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      fullWidth={true}
      maxWidth="lg"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title"></DialogTitle>
      <DialogContent>
        <Cropper
          src={image}
          style={{ height: 400 }}
          aspectRatio={5 / 3}
          minCropBoxHeight={100}
          minCropBoxWidth={100}
          guides={false}
          checkOrientation={false}
          onInitialized={(instance) => {
            setCropper(instance);
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button color="error" onClick={handleClose}>
          Anuluj
        </Button>
        <Button onClick={() => getCropData()}>Ok</Button>
      </DialogActions>
    </Dialog>
  );
}

export default CropImageDialog;
